<div style="width: 500px; height: 300px; padding: 20px;">
    <h2>Add Video Link</h2>
    <div class="form-text-label">Add Video Name*</div>
    <mat-form-field [floatLabel]="'never'" style="width: 300px;">
        <mat-label
            style="color: #999999; font-size: 14px; font-family: Montserrat; font-weight: 400; letter-spacing: 0.20px; word-wrap: break-word">Type
            here</mat-label>
        <textarea class="text-area-style" [(ngModel)]="videoName" minlength="2" matInput></textarea>
    </mat-form-field>
    <div class="form-text-label">Add Video Link*</div>
    <mat-form-field [floatLabel]="'never'" style="width: 300px;">
        <mat-label
            style="color: #999999; font-size: 14px; font-family: Montserrat; font-weight: 400; letter-spacing: 0.20px; word-wrap: break-word">Type
            here</mat-label>
        <textarea [(ngModel)]="videoLink" class="text-area-style" minlength="2" matInput></textarea>
    </mat-form-field>

    <button *ngIf="thumbNailName==''" class="media-upload-btn" (click)="uploadThumbNail.click()"
        style="width: auto;height: auto;margin-left: 20px;">
        <span class="media-upload-btn-txt">Upload Thumbnail</span>
    </button>
    <input #uploadThumbNail type="file" (change)="inputMediathumbNail($event)" accept="image/png, image/jpeg"
        style="display: none;">
    <div *ngIf="thumbNailName!=''" class="uploaded-media-div" style="height: auto;">
        <span class="uploaded-media-text">{{thumbNailName}}</span>
    </div>
    <div>
        <button mat-button color="primary" (click)="saveVideoLink()">Save</button>
    </div>
</div>